import { NgIf } from "@angular/common";
import { Component, EventEmitter, Input, Output, input } from "@angular/core";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";

@Component({
    selector: "app-upload",
    standalone: true,
    imports: [MatIconModule, MatFormFieldModule, NgIf],
    templateUrl: "./upload.component.html",
    styleUrl: "./upload.component.scss",
})
export class UploadComponent {
    @Input()
    requiredFileType: string;
    @Input()
    label: string;

    @Input()
    isMultiple?: boolean;

    @Input()
    isErroring: boolean;

    @Input()
    errorMessage?: string;

    @Output() fileOutputEvent = new EventEmitter<File | File[]>();

    @Input()
    fileName: string;

    constructor() {}

    onFileSelected(event: Event) {
        const target = event.target as HTMLInputElement;
        const files: File[] = Array.from(target.files as FileList);

        if (files && files.length > 0) {
            this.fileOutputEvent.emit(Array.from(files));
        }
    }
}
